import {addDays, DateArg, formatDate, isSameDay, isSameMonth} from "date-fns";
import {Button, ButtonProps, Sheet, SheetProps, Stack} from "@mui/joy";
import {useState} from "react";
import {DatePicker} from "@mui/x-date-pickers";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCalendar} from "@fortawesome/pro-regular-svg-icons";

// undefined is treated as today
export function makeMinimalDateLabel(when: DateArg<Date> | undefined): string {
    const now = new Date();
    if (!when || isSameDay(now, when)) {
        return "今日";
    }
    if (isSameMonth(now, when)) {
        return formatDate(when, "d日");
    } else {
        return formatDate(when, "M月d日");
    }
}

export interface DateBrowserOwnProps {
    day?: DateArg<Date>;
    onDayChange: (nv: DateArg<Date> | undefined) => void;
}

export interface DateBrowserProps extends Omit<SheetProps, "children" | "slots">,
    DateBrowserOwnProps {
}

interface DateButtonProps extends Omit<ButtonProps, "children">,
    DateBrowserOwnProps {
}

function DateButton(props: DateButtonProps) {
    const {
        day,
        onDayChange,
        ...rest
    } = props;

    return <Button {...rest} onClick={() => {
        onDayChange(day);
    }}>
        {makeMinimalDateLabel(day)}
    </Button>
}

// interface DatePickerTriggerProps extends UseDateFieldProps<false>, DatePickerSlotProps<false> {
//     setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
// }
//
// function DatePickerTrigger(props: DatePickerTriggerProps) {
//     const {
//         setIsOpen,
//         label,
//         id,
//         disabled,
//         InputProps: {ref} = {},
//         inputProps: {"aria-label": ariaLabel} = {},
//     } = props;
//
//     return <Button
//         variant="outlined"
//         id={id}
//         disabled={disabled}
//         ref={ref}
//         aria-label={ariaLabel}
//         onClick={() => setIsOpen?.((prev) => !prev)}
//     >
//         {label}
//     </Button>
// }

export function DateBrowser(props: DateBrowserProps) {
    const {
        day,
        onDayChange,
        color: inColor,
        variant: inVariant,
        ...rest
    } = props;

    const color = inColor ?? "neutral";
    const variant = inVariant ?? "outlined";
    const [isPickerOpen, setIsPickerOpen]
        = useState<boolean>(false);
    const dayDate = day ? new Date(day) : new Date();

    return <Sheet {...{color, variant: "plain", ...rest}}>
        <Stack direction="row" spacing={2.4}>
            <DateButton color={color} variant={variant}
                        day={addDays(dayDate, -1)}
                        onDayChange={(nv) => {
                            onDayChange(nv);
                        }}/>
            <DatePicker value={dayDate}
                        defaultValue={dayDate}
                        label={<Stack direction="column" spacing={0.8} sx={{alignItems: "center"}}>
                            <FontAwesomeIcon icon={faCalendar}/>
                            {makeMinimalDateLabel(day)}
                        </Stack>
                        }
                        // slots={{field: DatePickerTrigger}}
                        // slotProps={{field: {setIsOpen: setIsPickerOpen}} as any}
                        open={isPickerOpen}
                        onClose={() => {
                            setIsPickerOpen(false);
                        }}
                        onOpen={() => {
                            setIsPickerOpen(true);
                        }}
                        onChange={(nv) => {
                            if (nv) {
                                onDayChange(nv);
                            }
                        }}
            />
             <DateButton color={color} variant={variant}
                        day={addDays(dayDate, 1)}
                        onDayChange={onDayChange}/>
        </Stack>
    </Sheet>
}